import React from "react";
import { ParticipantContextProps } from "../models/contexts/participant-context.model";

export const ParticipantContext = React.createContext<ParticipantContextProps>({
	participant: undefined,
	allEhrProviders: undefined,
	onRefresh: () => {
		return new Promise<void>(() => {});
	},
});
